var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 37.3332C19.1667 43.9318 19.1667 47.2335 21.2177 49.2822C22.7133 50.7802 24.8763 51.1838 28.5 51.2935M19.1667 18.6665C19.1667 12.0678 19.1667 8.76617 21.2177 6.7175C23.2663 4.6665 26.568 4.6665 33.1667 4.6665H35.5C42.0987 4.6665 45.4003 4.6665 47.449 6.7175C49.5 8.76617 49.5 12.0678 49.5 18.6665V37.3332C49.5 43.9318 49.5 47.2335 47.449 49.2822C45.657 51.0765 42.9083 51.3005 37.8333 51.3285M7.5 22.1665V33.8332C7.5 39.3328 7.5 42.0815 9.208 43.7918C10.916 45.5022 13.667 45.4998 19.1667 45.4998M9.208 12.2078C10.916 10.4998 13.667 10.4998 19.1667 10.4998",
    stroke: "#7663EB",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 27.9998H35.5M35.5 27.9998L29.6667 33.8332M35.5 27.9998L29.6667 22.1665",
    stroke: "#7663EB",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 10,
    fill: "#7663EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBroken);
export default __webpack_public_path__ + "static/media/login-broken.e85ccd45c5ab996749daca82077420d2.svg";
export { ForwardRef as ReactComponent };